import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import ContentLayout from "../../component/ContentLayout";
import { useParams } from "react-router-dom";
import { Context } from "../../component/Context/ErrorContext";
import axios from "../../util/axios";
import UserModal from "../../component/UserModal";
import UserReferModal from "../../component/UserReferModal";
import { deviceList } from "../../constant/deviceList";

const Driver = () => {
  const { setError } = useContext(Context);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState<any>(null);
  const [drivingActivityData, setDrivingActivityData] = useState<any>(null);
  const [isUserModal, setIsUserModal] = useState(false);
  const [isUserReferModal, setIsUserReferModal] = useState(false);
  const [isEdit, setIsEdit] = useState({
    isPinEdit: false,
    isCashEdit: false,
  });
  const [user, setUser] = useState<any>({
    id: params?.id,
    firstname: "",
    middlename: "",
    lastname: "",
    email: "",
    phone: "+1",
    userreferenceid: "",
    dob: "",
    gender: "M",
    zip: "",
    city: "",
    state: "",
    refferalcode: "",
    userreferrallink: "",
    // registered: "",
    // license_number: "",
    // license_address: "",
    // license_issue_date: "",
    // license_expiry_date: "",
    // old_id: "",
  });
  const [userRefer, setUserRefer] = useState<any>({
    id: params?.id,
    firstname: "",
    middlename: "",
    lastname: "",
    email: "",
    phone: "+1",
    userreferenceid: "",
    dob: "",
    gender: "M",
    zip: "",
    city: "",
    state: "",
    refferalcode: "",
    userreferrallink: "",
    // registered: "",
    // license_number: "",
    // license_address: "",
    // license_issue_date: "",
    // license_expiry_date: "",
    // old_id: "",
  });
  const [updatedValue, setUpdatedValue] = useState({
    new_pin: "",
    new_cash: 0,
  });

  const getDashBoardData = async (id?: any) => {
    setLoading(true);
    axios({
      URL: `/omw/get-user-detail/${id || params?.id}`,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data;
        setUpdatedValue((pre) => ({
          ...pre,
          new_pin: data?.pin,
          new_cash: data?.available_cash,
        }));
        setUserData(data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };
  const updatedValueHandler = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    setUpdatedValue((pre) => ({ ...pre, [name]: value }));
  };
  const getDrivingActivityData = async (id: string) => {
    setLoading(true);
    axios({
      URL: `/omw/admin-get-user-activity/${id}`,
      method: "GET",
    })
      .then((res) => {
        setDrivingActivityData(res?.data?.data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (params?.id) {
      getDashBoardData(params?.id);
      getDrivingActivityData(params?.id);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);

  const updateUserPin = async () => {
    if (updatedValue?.new_pin !== userData?.ipin) {
      setLoading(true);
      await axios({
        URL: `/omw/update-user-pin/${params?.id}`,
        method: "PUT",
        data: {
          new_pin: updatedValue?.new_pin || userData?.ipin,
        },
      })
        .then((res: any) => {
          setUserData((pre: any) => ({
            ...pre,
            ipin: res.data?.data?.new_pin,
          }));
        })
        .catch((err) => setError(err?.response?.data?.message))
        .finally(() => setLoading(false));
    }
    setIsEdit((pre) => ({
      ...pre,
      isPinEdit: !pre.isPinEdit,
    }));
  };

  const updateAvailableCash = async () => {
    if (updatedValue?.new_cash !== userData?.available_cash) {
      setLoading(true);
      await axios({
        URL: `/omw/update-user-cash/${params?.id}`,
        method: "PUT",
        data: {
          new_cash: updatedValue?.new_cash,
        },
      })
        .then((res: any) => {
          setUserData((pre: any) => ({
            ...pre,
            available_cash: res.data?.data?.new_cash,
          }));
        })
        .catch((err) => setError(err?.response?.data?.message))
        .finally(() => setLoading(false));
    }
    setIsEdit((pre) => ({
      ...pre,
      isCashEdit: !pre.isCashEdit,
    }));
  };

  const updateUserProfile = async () => {
    setLoading(true);
    const data = {
      id: user?.id,
      first_name: user?.firstname,
      middle_name: user?.middlename,
      last_name: user?.lastname,
      email: user?.email,
      phone: user?.phone,
      user_reference_id: user?.userreferenceid,
      dob: user?.dob,
      gender: user?.gender,
      zipcode: user?.zip,
      city: user?.city,
      state: user?.state,
      refferal_code: user?.refferalcode,
      user_referral_link: user?.userreferrallink,
      // registered: moment("YYYY-MM-DD"),
      // firstname: user?.firstname,
      // lastname: user?.lastname,
      // referral: user?.refferalcode,
      // sex:"",
      // referred_by: "",
      // old_id: user?.old_id || params?.id,
      // licenses: [
      //   {
      //     license_number: user?.license_number,
      //     license_address: user?.license_address,
      //     city: user?.city,
      //     state: user?.state,
      //     zipcode: user?.zip,
      //     license_issue_date: user?.license_issue_date,
      //     license_expiry_date: user?.license_expiry_date,
      //   },
      // ],
    };
    await axios({
      URL: `/omw/admin/update-user/${params?.id}`,
      method: "PUT",
      data: data,
    })
      .then((res: any) => {
        getDashBoardData(params?.id);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ContentLayout className={"items-start"}>
      <div className={"bg-white w-full rounded-2xl flex flex-col"}>
        <div
          className={
            "bg-primary p-4 rounded-tr-2xl rounded-tl-2xl flex justify-between"
          }
        >
          <p
            className={
              "border-b border-primary border-solid text-xl font-bold text-white"
            }
          >
            Referrals {userData?.number_of_referral || 0}
          </p>
          {/*<p*/}
          {/*  className={*/}
          {/*    "border-b border-primary border-solid text-xl font-bold text-white"*/}
          {/*  }*/}
          {/*>*/}
          {/*  Archie Yes {moment().format("MM-DD-YYYY")}*/}
          {/*</p>*/}
        </div>
        <div
          className={"flex p-4 gap-5 md:flex-row flex-col-reverse flex-wrap"}
        >
          <div className={"flex flex-col min-w-[247px] justify-between"}>
            <div className={"flex flex-col gap-5"}>
              <div className={"flex flex-col h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Driver ID</p>
                <p className={"text-sm text-left"}>{params?.id}</p>
              </div>
              <div className={"flex flex-col h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Reference Id</p>
                <p className={"text-sm text-left"}>
                  {userData?.user_reference_id || "-"}
                </p>
              </div>
              <div className={"flex flex-col h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Referral Code</p>
                <p className={"text-sm text-left"}>
                  {userData?.referral_code || "-"}
                </p>
              </div>
              <div className={"flex flex-col h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Referral Link</p>
                <p className={"text-sm text-left"}>
                  {userData?.user_referral_link || "-"}
                </p>
              </div>
            </div>
            <button
              className={
                "bg-primary text-white p-3 rounded-2xl disabled:cursor-not-allowed"
              }
              onClick={() => {
                setIsUserModal(!isUserModal);
                setUser((pre: any) => ({
                  ...pre,
                  id: params?.id,
                  firstname: userData.first_name,
                  middlename: userData.middle_name,
                  lastname: userData.last_name,
                  email: userData.email,
                  phone: userData?.phone,
                  userreferenceid: userData.user_reference_id,
                  dob: userData.dob,
                  gender: userData.gender,
                  zip: userData.zipcode,
                  state: userData.state,
                  city: userData?.city,
                  refferalcode: userData?.referral_code,
                  userreferrallink: userData?.user_referral_link,
                  // referred_by: userData?.referred_by,
                  // sex: userData.sex,
                  // old_id: params?.id,
                }));
              }}
              disabled={loading}
            >
              Edit
            </button>
          </div>
          <div className={"flex flex-col w-full max-w-[500px] gap-5"}>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>First Name</p>
                <p className={"text-sm text-left"}>
                  {userData?.first_name || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Middle Name</p>
                <p className={"text-sm text-left"}>
                  {userData?.middle_name || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Last Name</p>
                <p className={"text-sm text-left"}>
                  {userData?.last_name || "-"}
                </p>
              </div>
            </div>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>
                  Email Address{" "}
                  <ContentCopyIcon
                    className={"ml-2 cursor-pointer"}
                    onClick={() =>
                      navigator.clipboard.writeText(userData?.email)
                    }
                  />
                </p>
                <p className={"text-sm text-left"}>{userData?.email || "-"}</p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>
                  Phone{" "}
                  <ContentCopyIcon
                    className={"ml-2 cursor-pointer"}
                    onClick={() =>
                      navigator.clipboard.writeText(userData?.phone)
                    }
                  />
                </p>
                <p className={"text-sm text-left"}>{userData?.phone || "-"}</p>
              </div>
            </div>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Gender</p>
                <p className={"text-sm text-left"}>{userData?.gender || "-"}</p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>DOB</p>
                <p className={"text-sm text-left"}>
                  {/*{userData?.dob || moment().format("MM-DD-YYYY")}*/}
                  {userData?.dob
                    ? moment(userData?.dob).format("MM-DD-YYYY")
                    : "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Age</p>
                <p className={"text-sm text-left"}>
                  {moment().diff(moment(userData?.dob), "years") || "34"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>
                  Pin{" "}
                  {!isEdit?.isPinEdit && (
                    <EditIcon
                      className={"cursor-pointer w-[18px]"}
                      onClick={() =>
                        setIsEdit((pre) => ({
                          ...pre,
                          isPinEdit: !pre.isPinEdit,
                        }))
                      }
                    />
                  )}
                </p>
                {isEdit?.isPinEdit ? (
                  <div className={"flex flex-row gap-1"}>
                    <input
                      className={
                        "w-full border border-gray-200 rounded-md outline-none"
                      }
                      name={"new_pin"}
                      value={updatedValue.new_pin}
                      defaultValue={userData?.ipin}
                      onChange={updatedValueHandler}
                    />
                    <button
                      className={
                        "bg-primary text-white p-1 rounded-md w-[60px]"
                      }
                      onClick={() => updateUserPin()}
                    >
                      SAVE
                    </button>
                  </div>
                ) : (
                  <p className={"text-sm text-left"}>{userData?.ipin || "-"}</p>
                )}
              </div>
            </div>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>City</p>
                <p className={"text-sm text-left"}>{userData?.city || "-"}</p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>State</p>
                <p className={"text-sm text-left"}>{userData?.state || "-"}</p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Zip Code</p>
                <p className={"text-sm text-left"}>
                  {userData?.zipcode || "-"}
                </p>
              </div>
            </div>
            {/*<div className={"flex justify-between gap-2"}>*/}
            {/*<div className={"flex flex-col flex-1 h-[57px]"}>*/}
            {/*  <p className={"text-base font-bold text-left"}>Zip Code</p>*/}
            {/*  <p className={"text-sm text-left"}>{userData?.zip || "-"}</p>*/}
            {/*</div>*/}
            {/*<div className={"flex flex-col flex-1 h-[57px]"}>*/}
            {/*  <p className={"text-base font-bold text-left"}>Gender</p>*/}
            {/*  <p className={"text-sm text-left min-w-[200px]"}>*/}
            {/*    {userData?.sex || "-"}*/}
            {/*  </p>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*<div className={"flex justify-between gap-2"}>*/}
            {/*  <div className={"flex flex-col flex-1 h-[57px]"}>*/}
            {/*    <p className={"text-base font-bold text-left"}>Zip Code</p>*/}
            {/*    <p className={"text-sm text-left"}>{userData?.zip || "-"}</p>*/}
            {/*  </div>*/}
            {/*  <div className={"flex-1"}></div>*/}
            {/*</div>*/}
            {/*<div className={"flex justify-between gap-2"}>*/}
            {/*  <div className={"flex flex-col flex-1 h-[57px]"}>*/}
            {/*    <p className={"text-base font-bold text-left"}>Sex</p>*/}
            {/*    <p className={"text-sm text-left min-w-[200px]"}>*/}
            {/*      {userData?.sex || "-"}*/}
            {/*    </p>*/}
            {/*  </div>*/}
            {/*  <div className={"flex-1"}></div>*/}
            {/*</div>*/}

            <button
              className={
                "w-1/2 bg-primary text-white p-3 rounded-2xl disabled:cursor-not-allowed"
              }
              onClick={() => {
                setIsUserReferModal(!isUserReferModal);
                setUserRefer((pre: any) => ({
                  ...pre,
                  id: params?.id,
                  firstname: userData.first_name,
                  middlename: userData.middle_name,
                  lastname: userData.last_name,
                  email: userData.email,
                  phone: userData?.phone,
                  userreferenceid: userData.user_reference_id,
                  dob: userData.dob,
                  gender: userData.gender,
                  zip: userData.zipcode,
                  state: userData.state,
                  city: userData?.city,
                  refferalcode: userData?.referral_code,
                  userreferrallink: userData?.user_referral_link,
                  // referred_by: userData?.referred_by,
                  // sex: userData.sex,
                  // old_id: params?.id,
                }));
              }}
              disabled={loading}
            >
              Refer
            </button>
          </div>
          <div className={"flex flex-col flex-1 justify-between"}>
            <div className={"flex flex-col gap-5 items-start md:items-end"}>
              <p className={"text-4xl font-bold text-right"}>
                Available Cash:{" "}
                {!isEdit?.isCashEdit && (
                  <EditIcon
                    className={"cursor-pointer"}
                    onClick={() =>
                      setIsEdit((pre) => ({
                        ...pre,
                        isCashEdit: !pre.isCashEdit,
                      }))
                    }
                  />
                )}
              </p>
              {isEdit?.isCashEdit ? (
                <div className={"flex flex-row gap-1 justify-end"}>
                  <input
                    className={
                      "w-full border border-gray-200 rounded-md outline-none max-w-[300px]"
                    }
                    name={"new_cash"}
                    value={updatedValue.new_cash}
                    onChange={updatedValueHandler}
                  />
                  <button
                    className={"bg-primary text-white p-1 rounded-md w-[60px]"}
                    onClick={() => updateAvailableCash()}
                  >
                    SAVE
                  </button>
                </div>
              ) : (
                <p className={"text-4xl text-right"}>
                  ${userData?.available_cash || 0}
                </p>
              )}
            </div>
          </div>
        </div>
        <div
          className={
            "bg-primary p-4 rounded-br-2xl rounded-bl-2xl flex justify-between"
          }
        >
          <div className={"flex flex-col"}>
            <p className={"text-base font-bold text-left text-white"}>
              OS:{" "}
              <span className={"text-sm"}>
                {" "}
                {userData?.device_details?.devicetype}{" "}
                {userData?.device_details?.OSversion}{" "}
              </span>
            </p>
            <p className={"text-base font-bold text-left text-white"}>
              Device:{" "}
              <span className={"text-sm"}>
                {" "}
                {userData?.device_details?.devicetype === "ios"
                  ? deviceList.find(
                      (device) =>
                        device.serial_number ===
                        userData?.device_details?.devicemodel
                    )?.model_number || userData?.device_details?.devicemodel
                  : userData?.device_details?.devicemodel}{" "}
              </span>
            </p>
          </div>
          <div className={"flex flex-col"}>
            <p className={"text-base font-bold text-right text-white"}>
              Referred By
            </p>
            <p className={"text-sm font-bold text-right text-white"}>
              {userData?.referred_by?.name || "-"}
            </p>
          </div>
        </div>
      </div>
      <div
        className={
          "gap-4 mt-4 w-full max-h-[800px] h-full flex flex-col md:flex-row"
        }
      >
        <div className={"w-full flex flex-col items-start md:w-1/2"}>
          <p className={"text-xl font-bold text-primary"}>Driving Activity</p>
          <div
            className={
              "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 w-full"
            }
          >
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white"}>Miles Driven</p>
              <p className={"text-white text-2xl font-bold"}>
                {+drivingActivityData?.total_distance_all_time || 0}
              </p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white"}>Total Earned</p>
              <p className={"text-white text-2xl font-bold"}>
                ${drivingActivityData?.total_earned_all_time || 0}
              </p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white"}>Miles Driven Today</p>
              <p className={"text-white text-2xl font-bold"}>
                {drivingActivityData?.total_earned_last_24_hours || 0}
              </p>
            </div>
          </div>
          <TableContainer
            component={Paper}
            className={"my-4"}
            sx={{ maxHeight: 500 }}
          >
            <Table
              sx={{ minWidth: 500 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Miles Driven</TableCell>
                  <TableCell>Earned</TableCell>
                  <TableCell>Referral Earned</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {drivingActivityData?.activity?.map((row: any) => (
                  <TableRow
                    key={row.date}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      {moment(row?.date).format("MM-DD-YYYY")}
                    </TableCell>
                    <TableCell>{(+row?.distance || 0).toFixed(2)}</TableCell>
                    <TableCell>${row?.total_earned_dollars}</TableCell>
                    <TableCell>${row?.total_earned_refferal_dollar ?? 0}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className={"w-full flex flex-col items-start md:w-1/2"}>
          <div className={"w-full flex justify-between"}>
            <p className={"text-xl font-bold text-primary"}>
              Referral Activity
            </p>
          </div>
          <div
            className={
              "w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4"
            }
          >
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white"}>Miles Driven</p>
              <p className={"text-white text-2xl font-bold"}>-</p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white"}>Total Earned</p>
              <p className={"text-white text-2xl font-bold"}>-</p>
            </div>
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white"}>Miles Driven Today</p>
              <p className={"text-white text-2xl font-bold"}>-</p>
            </div>
          </div>
          <TableContainer
            component={Paper}
            className={"my-4"}
            sx={{ maxHeight: 500 }}
          >
            <Table
              sx={{ minWidth: 500 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Referral</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userData?.refferal_list?.map((row: any) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      {moment(row.created_at).format("MM-DD-YYYY")}
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <div
        className={
          "gap-4 mt-4 w-full max-h-[800px] h-full flex flex-col md:flex-row"
        }
      >
        {/*<div className={"w-full flex flex-col items-start md:w-1/2"}>*/}
        {/*  <p className={"text-xl font-bold text-primary"}>Payment Activity</p>*/}
        {/*  <div*/}
        {/*    className={*/}
        {/*      "w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4"*/}
        {/*    }*/}
        {/*  >*/}
        {/*    <div className={"flex flex-col gap-1"}>*/}
        {/*      <p className={"text-md text-[#2d2e2d] font-bold text-left"}>*/}
        {/*        Taken: <span className={"text-[#195aad] text-lg"}>$312.00</span>*/}
        {/*      </p>*/}
        {/*      <div className={"flex flex-col bg-primary p-4 gap-1"}>*/}
        {/*        <p className={"text-white text-2xl font-bold"}>N/A</p>*/}
        {/*        <p className={"text-white"}>&nbsp;</p>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className={"flex flex-col gap-1"}>*/}
        {/*      <p className={"text-md text-[#2d2e2d] font-bold text-left"}>*/}
        {/*        Available:{" "}*/}
        {/*        <span className={"text-[#195aad] text-lg"}>$192.00</span>*/}
        {/*      </p>*/}
        {/*      <div className={"flex flex-col bg-primary p-4 gap-1"}>*/}
        {/*        <p className={"text-white text-2xl font-bold"}>$0.00</p>*/}
        {/*        <p className={"text-white"}>Total Ad Purchases</p>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className={"flex flex-col gap-1"}>*/}
        {/*      <p className={"text-md text-[#2d2e2d] font-bold text-left"}>*/}
        {/*        Pending:{" "}*/}
        {/*        <span className={"text-[#195aad] text-lg"}>$120.00</span>*/}
        {/*      </p>*/}
        {/*      <div className={"flex flex-col bg-primary p-4 gap-1"}>*/}
        {/*        <p className={"text-white text-2xl font-bold"}>$0.00</p>*/}
        {/*        <p className={"text-white"}>Total Rewards</p>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className={"flex flex-col gap-1"}>*/}
        {/*      <p className={"text-md text-[#2d2e2d] font-bold text-left"}>*/}
        {/*        Transferred:{" "}*/}
        {/*        <span className={"text-[#195aad] text-lg"}>$0.00</span>*/}
        {/*      </p>*/}
        {/*      <div className={"flex flex-col bg-primary p-4 gap-1"}>*/}
        {/*        <p className={"text-white text-2xl font-bold"}>0</p>*/}
        {/*        <p className={"text-white"}>Linked Credit Card</p>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <TableContainer*/}
        {/*    component={Paper}*/}
        {/*    className={"my-4"}*/}
        {/*    sx={{ maxHeight: 500 }}*/}
        {/*  >*/}
        {/*    <Table*/}
        {/*      sx={{ minWidth: 500 }}*/}
        {/*      stickyHeader*/}
        {/*      aria-label="sticky table"*/}
        {/*    >*/}
        {/*      <TableHead>*/}
        {/*        <TableRow>*/}
        {/*          <TableCell>Purchase ID</TableCell>*/}
        {/*          <TableCell>Date</TableCell>*/}
        {/*          <TableCell>Purchase Price</TableCell>*/}
        {/*          <TableCell>Earned</TableCell>*/}
        {/*        </TableRow>*/}
        {/*      </TableHead>*/}
        {/*      <TableBody>*/}
        {/*        {rowsPayment.map((row) => (*/}
        {/*          <TableRow*/}
        {/*            key={row.id}*/}
        {/*            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}*/}
        {/*          >*/}
        {/*            <TableCell>{row.id}</TableCell>*/}
        {/*            <TableCell>{row.date}</TableCell>*/}
        {/*            <TableCell>{row.price}</TableCell>*/}
        {/*            <TableCell>${row.earned}</TableCell>*/}
        {/*          </TableRow>*/}
        {/*        ))}*/}
        {/*      </TableBody>*/}
        {/*    </Table>*/}
        {/*  </TableContainer>*/}
        {/*</div>*/}
      </div>
      <UserModal
        open={isUserModal}
        onClose={() => setIsUserModal(false)}
        user={user}
        setUser={setUser}
        onSubmit={updateUserProfile}
        isEdit
      />
      <UserReferModal
        open={isUserReferModal}
        onClose={() => setIsUserReferModal(false)}
        user={userRefer}
        getDashBoardData={getDashBoardData}
      />
    </ContentLayout>
  );
};

export default Driver;
